import { ListType } from '../constants';
import { editableListInitialStateFactory, editableListReducerFactory } from '../reducers';
import { compareValue, findModifiedItem, getModifiedItem, getPersistedItem, updatePersistedValue } from './selectors';
import {
  CodeDescriptionMetadata, CodeDescriptionSearchData, CodeDescriptionSearchModel,
  CodeDescriptionValidationError, ModifiedCodeDescription
} from './types-store';
import { removeValidationForCodeDescription } from './validation';

export const INITIAL_STATE = editableListInitialStateFactory<
  CodeDescriptionMetadata,
  CodeDescriptionSearchData,
  ModifiedCodeDescription,
  CodeDescriptionSearchModel,
  CodeDescriptionValidationError
>();

export const reducer = editableListReducerFactory<
  CodeDescriptionMetadata,
  CodeDescriptionSearchData,
  ModifiedCodeDescription,
  CodeDescriptionSearchModel,
  CodeDescriptionValidationError
>(
  ListType.code,
  INITIAL_STATE,
  getModifiedItem,
  findModifiedItem,
  getPersistedItem,
  compareValue,
  updatePersistedValue,
  removeValidationForCodeDescription
);
